import { render, staticRenderFns } from "./SessionSection.vue?vue&type=template&id=d8de9516&scoped=true"
import script from "./SessionSection.vue?vue&type=script&lang=js"
export * from "./SessionSection.vue?vue&type=script&lang=js"
import style0 from "./SessionSection.vue?vue&type=style&index=0&id=d8de9516&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8de9516",
  null
  
)

export default component.exports